import { PayrollEffects } from './payroll.effects';
import { PayrollExtraEffects } from './payroll.extra.effects';
import { PayrollRuleEffects } from './payroll.rule.effects';

export { PayrollEffects, PayrollExtraEffects, PayrollRuleEffects };
